/**
 * crypt/decrypt — porta de [application.js:606-629]. Usado no atalho `?shortcut=<crypt>`
 * das notificações da extensão (openShortcut [9114]): o parâmetro é um JSON criptografado
 * (base64 → reverso → base64, com 3 hex aleatórios em cada ponta). decrypt desfaz isso.
 */

/** base64 de uma string UTF-8 (simétrico ao b64DecodeUnicode do decrypt). */
function b64EncodeUnicode(str: string): string {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) => String.fromCharCode(parseInt(p1, 16))),
  );
}

/** Codifica um valor no formato do legado (espelho do decrypt; UTF-8-safe). */
export function crypt(pure: unknown): string {
  const json = JSON.stringify(pure);
  let transform = b64EncodeUnicode(json);
  let reverse = '';
  for (let i = transform.length - 1; i >= 0; i--) reverse += transform[i];
  transform = btoa(reverse.replace(/=/g, ''));
  const hex = (): string => Math.floor(Math.random() * 0x1000).toString(16).padStart(3, '0');
  return hex() + transform.replace(/=/g, '') + hex();
}

/** Re-adiciona o padding `=` que o crypt remove (o legado confia na leniência do atob do
 * browser; re-padar deixa o decode correto em qualquer ambiente). */
function pad(s: string): string {
  return s + '='.repeat((4 - (s.length % 4)) % 4);
}

function b64DecodeUnicode(str: string): string {
  return decodeURIComponent(
    atob(pad(str))
      .split('')
      .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
      .join(''),
  );
}

/** Desfaz o crypt: base64 → reverte → base64(unicode). Lança se a string for inválida. */
export function decrypt(str: string): string {
  let reversed = atob(pad(str));
  reversed = [...reversed].reverse().join('');
  return b64DecodeUnicode(reversed);
}
